export const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_KEY

export const SEGMENT_TOKEN = process.env.REACT_APP_SEGMENT_TOKEN

export const REACT_APP_AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY

export const SATISMETER_TOKEN = process.env.REACT_APP_SATISMETER_TOKEN

export const ANALYTICS_ENABLED = process.env.REACT_APP_ANALYTICS_ENABLED
